import {allBranchesSpecification} from '../../../../../components/BranchSpecificationSelect/BranchSpecificationSelect.consts'
import {getDefaultBranchSpecification} from '../../../../../components/BranchSpecificationSelect/BranchSpecificationSelect.utils'

export const ROOT_REPOSITORY_KEY = 'Root'
export const getRepositoryKey = (isRoot: boolean, index?: number) =>
  isRoot ? ROOT_REPOSITORY_KEY : index
export const getBranchesToMonitor = (branchSpec: string | null, defaultBranch: string) => {
  if (branchSpec === allBranchesSpecification) {
    return 'All branches'
  }

  if (!branchSpec || branchSpec === getDefaultBranchSpecification(defaultBranch)) {
    return 'Only default branch'
  }

  return 'Specific branches'
}
export const canShowPublishStatusSection = ({
  publishingSupported,
  connectionId,
}: {
  publishingSupported?: boolean
  connectionId?: string
}) => publishingSupported === true || (publishingSupported == null && connectionId != null)
